import(/* webpackMode: "eager" */ "/app/apps/web/src/app/workspace/error.tsx");
